import { useRef } from 'react';
import { useSignalRHub, type ConnectionStatus } from '@/realtime/useSignalRHub';

// Suspicious Trades live hub (/hubs/suspicious-trades). Server pushes
// OnPendingAlertCountChanged(count) → refresh the grid (keep page) + counts + badge.
export function useSuspiciousTradesHub({
  enabled,
  onPendingCountChanged,
}: {
  enabled: boolean;
  onPendingCountChanged: (count: number) => void;
}): { status: ConnectionStatus } {
  const onChangedRef = useRef(onPendingCountChanged);
  onChangedRef.current = onPendingCountChanged;

  const { status } = useSignalRHub({
    url: '/hubs/suspicious-trades',
    enabled,
    on: {
      OnPendingAlertCountChanged: (count) => {
        onChangedRef.current(Number(count));
      },
    },
  });

  return { status };
}
